import { FC, useEffect } from 'react';

import { Toaster } from 'react-hot-toast';

import Achievements from './components/Achievements/Achievements';
import Background from './components/Background/Background';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Skills from './components/Skills/Skills';
import { initializeScrollHandler } from './utils/scrollHandler';
import './styles/main.css';

const App: FC = () => {
  useEffect(() => {
    // Initialize scroll handler and store cleanup function
    const cleanup = initializeScrollHandler();
    return () => cleanup();
  }, []);

  return (
    <>
      <Toaster position="bottom-center" toastOptions={{ duration: 4000 }} />
      <Background />
      <div className="app-container">
        <Header />
        <main id="main-content" role="main">
          <article>
            <Hero />
            <section aria-labelledby="skills-heading">
              <Skills />
            </section>
            <section aria-labelledby="achievements-heading">
              <Achievements />
            </section>
            <section aria-labelledby="contact-heading">
              <Contact />
            </section>
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default App;
